module.exports = __webpack_public_path__ + "img/add-picture.0482174e.png";